import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { VnptuhAPI } from "api/VnptuhAPI";



export default function VnptuhTable(props) {

  const [Vnptuh, setVnptuh] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props


  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderVnptuh = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Producto", accessor: "producto", align: "right" },
      { Header: "Descripción", accessor: "descripcion", align: "left", },
      { Header: "Tipo", accessor: "tipo", align: "right" },
      { Header: "Linea", accessor: "linea", align: "right" },
      { Header: "Corte", accessor: "corte", align: "right" },
      { Header: "Aplicación", accessor: "aplicacion", align: "left", },
      { Header: "Adicionales", accessor: "adicionales", align: "left", },
      { Header: "Conexión", accessor: "conexion", align: "left", },
      { Header: "Manguera", accessor: "manguera", align: "left", },
      { Header: "Unión", accessor: "union", align: "left", },
    ];

    Vnptuh?.map((element) => {
      rows = [...rows,
      {
        producto: element.codigo,
        descripcion: element.descripcion,
        tipo: element.tipo,
        linea: element.linea,
        corte: Number(element.corte).toFixed(2),
        aplicacion: Number(element.aplicacion).toFixed(2),
        adicionales: Number(element.adicionales).toFixed(2),
        conexion: Number(element.conexion).toFixed(2),
        manguera: Number(element.manguera).toFixed(2),
        union: Number(element.union).toFixed(2),
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [Vnptuh])


  const getVnptuh = () => {
    setLoading(dispatch, true)
    return VnptuhAPI.index(true)
      .then(response => {
        setVnptuh(response.vnptuh)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getVnptuh)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Valores Nominales'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderVnptuh}
      </MDBox>
    </MDBox>
  )

}